import { useEffect, useRef } from "react";

/** Decorative only; the native cursor and every hit target remain untouched. */
export function PointerGlow() {
  const glow = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const preference = window.matchMedia(
      "(pointer: fine) and (hover: hover) and (prefers-reduced-motion: no-preference)",
    );
    let frame = 0;
    const hide = () => glow.current?.classList.remove("is-active");
    const move = (event: PointerEvent) => {
      if (!preference.matches || event.pointerType === "touch") return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!glow.current) return;
        glow.current.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0)`;
        glow.current.classList.add("is-active");
      });
    };
    window.addEventListener("pointermove", move, { passive: true });
    document.documentElement.addEventListener("pointerleave", hide);
    window.addEventListener("blur", hide);
    preference.addEventListener("change", hide);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("pointermove", move);
      document.documentElement.removeEventListener("pointerleave", hide);
      window.removeEventListener("blur", hide);
      preference.removeEventListener("change", hide);
    };
  }, []);
  return <div className="pointer-glow" ref={glow} aria-hidden="true" />;
}
